module.exports = __webpack_public_path__ + "img/logo.145b79ab.png";